export interface DraftSnapshot {
  values: Record<string, string>;
  assets: Record<string, { id: string; url: string }>;
}
/** One history for every bound field, including uploaded image identities. */
export class WebsiteDraftHistory {
  current: DraftSnapshot = { values: {}, assets: {} };
  private past: DraftSnapshot[] = [];
  private future: DraftSnapshot[] = [];
  private group = '';
  private at = 0;
  get canUndo() {
    return this.past.length > 0;
  }
  get canRedo() {
    return this.future.length > 0;
  }
  reset(values: Record<string, string>) {
    this.current = { values: { ...values }, assets: {} };
    this.past = [];
    this.future = [];
    this.boundary();
  }
  boundary() {
    this.group = '';
  }
  change(
    id: string,
    value: string,
    asset?: { id: string; url: string },
    discrete = false,
    now = Date.now(),
  ) {
    if (
      this.current.values[id] === value &&
      this.current.assets[id]?.id === asset?.id
    )
      return false;
    if (
      discrete ||
      this.group !== id ||
      now - this.at > 750 ||
      this.future.length
    ) {
      this.past.push(this.current);
      if (this.past.length > 100) this.past.shift();
    }
    const assets = { ...this.current.assets };
    if (asset) assets[id] = asset;
    else delete assets[id];
    this.current = { values: { ...this.current.values, [id]: value }, assets };
    this.future = [];
    this.group = discrete ? '' : id;
    this.at = now;
    return true;
  }
  undo() {
    const previous = this.past.pop();
    if (!previous) return false;
    this.future.push(this.current);
    this.current = previous;
    this.boundary();
    return true;
  }
  redo() {
    const next = this.future.pop();
    if (!next) return false;
    this.past.push(this.current);
    this.current = next;
    this.boundary();
    return true;
  }
}
